import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import Decorate from './Decorate';
import SelectLevel from './SelectLevel';

export default class DrawLightsInstructions extends Phaser.Scene
{
    static get KEY() { return 'Instructions'; }

    constructor()
    {
        super({ key: (DrawLightsInstructions).KEY });
    }

    create()
    {
        this.bg = this.add.rectangle(this.scale.width / 2, this.scale.height / 2, this.scale.width, this.scale.height, 0x0f75bc);

        let lightString = gameData.lightsEarned === 1 ? ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.results_screen.light") : ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.results_screen.lights");

        let line1 = ABCyaPhaser.Localization.instance.getLocalizedString("lights_information").replace("~", gameData.lightsEarned).replace("~", lightString);
        ABCyaPhaser.Text.addText(this.scale.width / 2, this.scale.height / 2 - 100, 55, 0xeeeeee, FontKeys._odin_roundedregular, line1, this, true);

        if (gameData.lightsEarned > 0)
        {
            let line2 = ABCyaPhaser.Localization.instance.getLocalizedString("lights_instructions");
            ABCyaPhaser.Text.addText(this.scale.width / 2, this.scale.height / 2 + 40, 50, 0xeeeeee, FontKeys._odin_roundedregular, line2, this, true);
        }
        else
        {
            let line2 = ABCyaPhaser.Localization.instance.getLocalizedString("math_fact_fun.please_try_again");
            ABCyaPhaser.Text.addText(this.scale.width / 2, this.scale.height / 2 + 40, 55, 0xeeeeee, FontKeys._odin_roundedregular, line2, this, true);
        }

        this.nextButton = ABCyaPhaser.Buttons.addSimpleButton(this.scale.width / 2 + 430, this.scale.height - 75, UIAssetKeys._sprites_go_button, null, () =>
        {
            ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
            this.leave();
        }, this).setScale(0.6);

        this.tweens.timeline(
            {
                tweens:
                    [
                        ABCyaPhaser.Tweens.createTween(this.nextButton, 500, { scale: 1, offset: 100 }, Phaser.Math.Easing.Quadratic.Out),
                        ABCyaPhaser.Tweens.createTween(this.nextButton, 200, { scale: 0.6, offset: 600 }, Phaser.Math.Easing.Quadratic.Out),
                    ],
            }
        );
    }

    leave()
    {
        if (gameData.lightsEarned > 0)
        {
            this.scene.start(Decorate.KEY);
        }
        else
        {
            this.scene.start(SelectLevel.KEY);
        }
    }
}